import {connect} from 'react-redux';

import axios from 'axios';
import { Platform, Linking} from "react-native";
import IncreaseCreditSatiaScreen from "../IncreaseCreditSatiaScreen";
import store from "../../../../../redux/store";
import {typeExport} from "../../../../../redux/store/type";
import {serviceActionSetWallet} from "../../../splash/action/ActionSplashSatiaScreen";
import HMAlert from "../../../../../customviews/HMAlert";
import i18n from "../../../../../I18n/i18n";
import {Tools} from "../../../../../tools/Tools";


const mapStateToProps = (state) => ({

    result: state.reducerIncreaseCreditSatiaScreen.result,

    showLoading: state.reducerIncreaseCreditSatiaScreen.showLoading,
    isLoading: state.reducerIncreaseCreditSatiaScreen.isLoading,

    NoInternetDialog: state.reducerIncreaseCreditSatiaScreen.NoInternetDialog,

    token: state.reducerSplashSatiaScreen.token,
    DataSplashSatiaScreen: state.reducerSplashSatiaScreen,


});


const mapDispatchToProps = (dispatch) => ({

    callService: (url, params, type, typeConnection, token) => dispatch(callWebservice(url, params, type, typeConnection, token)),

    callserviceActionRefresh: (user) => dispatch(serviceActionRefresh(user)),

    callServiceSetWallet: (data, typeWallet) => dispatch(serviceActionSetWallet(data, typeWallet)),


});


const getDataDisatch = (dispatch, url, params, type, typeConnection, token) => {

    dispatch(serviceActionPending());
    axios(
        {
            url: typeExport._baseUrlSatia + url + params,
            method: typeConnection,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                //  "Authorization": token,
            },
            timeout: typeExport._TIMEOUT,

        }
    )
        .then(response => {

        let data = response.data;

        switch (type) {


            case typeExport.typeSetIncreaseCredit:

                if (data.status === true) {

                    dispatch(serviceActionSuccess(data));

                    if (response.data.Url2)
                        Tools.GoLink(response.data.Url2,"self")
                 //   Linking.openURL(data.url).catch(err => console.error('An error occurred', err))

                } else {

                    dispatch(serviceActionSuccess(data));

                    HMAlert(
                        i18n.t('constant.message'),
                        response.data.message,
                        [
                            {
                                text: i18n.t('constant.ok'), onPress: () => {
                                    // NavigationService.Pop();
                                }


                            },

                        ],
                        {cancelable: true}
                    )

                }

                break;

            default:

        }

    }).catch((e) => {

        dispatch(serviceActionError(e))

    })

}

export const callWebservice = (url, params, type, typeConnection, token) => {

    return dispatch => {


        // NetInfo.isConnected.fetch().then(isConnected => {

        //     if (isConnected) {

        //         getDataDisatch(dispatch, url, params, type, typeConnection, token);

        //     }

        //     else {

        //         switch (type) {

        //

        //             case typeSetIncreaseCredit:

        //                 dispatch(serviceActionError("no connect"));

        //                 break;

        //             default:

        //         }

        //     }

        // });


        // NetInfo.getConnectionInfo().done(

        //     (isConnected) => {

        //         if (isConnected) {

        //             getDataDisatch(dispatch, url, params, type, typeConnection, token);

        //         }

        //         else {

        //             switch (type) {

        //

        //                 case typeExport.typeSetIncreaseCredit:

        //                     dispatch(serviceActionError("no connect"));

        //                     break;

        //                 default:

        //             }

        //         }

        //     }

        // )

        if (store.getState().reducerSplashSatiaScreen.Connection) {
            getDataDisatch(dispatch, url, params, type, typeConnection, token);
        } else {
            switch (type) {
                case typeExport.typeSetIncreaseCredit:
                    dispatch(serviceActionError('error_Connection'))

                    break;

                default:
            }
        }
  /*      if (store.getState().reducerSplashGetAllData.Connection) {

            getDataDisatch(dispatch, url, params, type, typeConnection, token);

        }

        else {

            switch (type) {


                case typeExport.typeSetIncreaseCredit:

                    if (data.status === true) {

                        dispatch(serviceActionSuccess(data));

                        Linking.openURL(data.url).catch(err => console.error('An error occurred', err))

                    } else {

                        dispatch(serviceActionSuccess(data));

                        alert(data.message)

                    }

                    break;

                default:

            }

        }*/



    }

}



export const serviceActionPending = () => ({

    type: typeExport.INCREASE_CREDIT_SERVICE_PENDING,

    NoInternetDialog: false,

    showLoading: true,

    failed: false,

})


export const serviceActionError = (error) => ({

    type: typeExport.INCREASE_CREDIT_SERVICE_ERROR,

    NoInternetDialog: true,

    showLoading: false,

    error: error,

    failed: true,


})


export const serviceActionSuccess = (data) => ({

    type: typeExport.INCREASE_CREDIT_SERVICE_SUCCESS,

    result: data,

    NoInternetDialog: false,

    showLoading: false,

    failed: false,

})

export const serviceActionRefresh = () => ({

    type: typeExport.INCREASE_CREDIT_SERVICE_REFRESH,

    NoInternetDialog: false,

    isLoading: false,

    results: null

})


export default connect(mapStateToProps, mapDispatchToProps)(IncreaseCreditSatiaScreen);


